<template>
  <div class="checkIn goals">
    <mu-content-block id="initialLoader" v-if="isLoading">
      <mu-circular-progress :size="32"></mu-circular-progress>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <mu-row style="align-items: center" gutter v-if="!isLoading">
      <mu-col width="100" desktop="100" tablet="100">
        <form novalidate @submit.prevent="submitForm">
          <div v-for="goal, index in goals" :key="`goal-${index}`">
            <div class="step-content" v-show="index === activeStep">
            <p class="bigTxt">Goal {{ index + 1 }}/{{ goals.length }}</p>
            <p class="bigTxt">
              When you first began the program, you told us you wanted to <strong v-text="goal.goal"></strong> and rated yourself a <strong v-text="evaluation.old"></strong> out of 10 in regards to reaching this goal.
            </p>
            <p class="bigTxt">How do you feel like you’re doing now?</p>
            <div class="sliderWrap">
              <mu-slider class="slider" v-model="evaluation.now" :min="slider.min" :step="slider.step" :max="slider.max" />
              <mu-row>
                <mu-col width="33" desktop="33" tablet="33" class="sliderLabel amount" v-text="slider.min"></mu-col>
                <mu-col width="33" desktop="33" tablet="33"></mu-col>
                <mu-col width="33" desktop="33" tablet="33" class="sliderLabel amount" v-text="slider.max"></mu-col>
              </mu-row>
            </div>
          </div>
          </div>
          <mu-raised-button
            :disabled="isProcessing || isFinished"
            type="button"
            @click.native="handleNext"
            :label="isProcessing ? $t('message.savingText') : (isLastPanel ? $t('message.saveText') : $t('message.nextText'))"
            secondary
            fullWidth
            />
        </form>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>
  import CheckInApi from '../../api/CheckIn';
  import userApi from '../../api/User';

  export default {
    data() {
      return {
        isLoading: true,
        activeStep: 0,
        isProcessing: false,
        isFinished: false,
        goals: [],
        model: [],
        slider: {
          min: 0,
          max: 10,
          step: 1,
        },
        evaluation: {
          old: 0,
          now: 0,
        },
      }
    },
    methods: {
      addToModel() {
        let self = this,
            goal = self.getActiveGoal;
        if(goal) {
          self.model.push({
            goal_id: goal.goal_id,
            evaluation: self.evaluation.now,
          });
        }
      },
      getGoals() {
        let self = this;
        userApi.getUserGoals().then(response => {
          let callback = response.data;
          self.goals = callback.goals;
          self.evaluation.old = callback.evaluation;
          self.evaluation.now = callback.evaluation;
          self.isLoading = false;
        });
      },
      handleNext () {
        let self = this;
        // if the active step matches the amount of goals marked AND is processing, DO NOT push extra goal evaluations
        if(self.activeStep == self.model.length && !self.isProcessing) {
          self.addToModel();
        }
        if(self.isLastPanel) {
          self.submitForm();
        } else {
          self.activeStep += 1;
        }
      },
      submitForm() {
        let self = this;
        self.isProcessing = true;
        CheckInApi.addGoals(self.model).then(response => {
          if(!response.data.error) {
            self.isProcessing = false;
            self.isFinished = true;
            self.$toastr.success('Your goal evaluation have been saved');
            // Return to wherever the check-in was triggered from (e.g. a lesson)
            // if a redirect was stored, otherwise fall back to the Dashboard.
            let redirect = window.sessionStorage.getItem('checkInRedirect');
            if (redirect) {
              window.sessionStorage.removeItem('checkInRedirect');
              self.$router.push(redirect);
            } else {
              self.$router.push({
                name: 'Dashboard'
              });
            }
          }
        }).catch(error => {
          if(error.response.data) {
            self.isProcessing = false;
            self.$toastr.error('Failed to save evaluation');
          }
        });
      }
    },
    computed: {
      getActiveGoal() {
        let self = this;
        return self.goals[self.activeStep];
      },
      isLastPanel() {
        let self = this;
        return self.goals.length === self.activeStep + 1;
      }
    },
    mounted() {
      let self = this;
      self.getGoals();
    }
  }
</script>

<style lang="less">


  .sliderWrap .mu-slider-fill {
    background: #3d8517 !important;
  }

  .checkIn {
    &.goals {
      .sliderWrap {
        margin: 24px 0;
        .sliderLabel {
          font-size: 16px;
          text-transform: uppercase;
          &.amount {
            font-size: 20px;
          }
          &:last-of-type {
            text-align: right;
          }
        }
        .slider {
          margin: 16px 0;
          .mu-slider-fill {
            height: 4px;

          }
          .mu-slider-thumb {
            background-color: #0179d5;
          }
          .mu-slider-track {
            background-color: #8CD1FF;
            overflow: hidden;
            border-radius: 5px;
            height: 4px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Goals.vue?f927c554